import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "buttonLabel", "structureField", "loader", "success"]
  static values = { generateUrl: String, statusUrl: String }

  connect() {
    this._inFlight = false
    this._pollTimer = null
    this._pollAttempts = 0
  }

  disconnect() {
    this._stopPolling()
  }

  async generate() {
    if (this._inFlight) return
    this._inFlight = true
    this._setLoading(true)

    try {
      const resp = await fetch(this.generateUrlValue, {
        method: "POST",
        headers: {
          "X-CSRF-Token": this._csrfToken(),
          "Accept": "application/json"
        }
      })

      if (!resp.ok) throw new Error(await resp.text())

      // Réponse immédiate {status:"running"}
      await resp.json()

      // Polling
      this._pollAttempts = 0
      this._startPolling()
    } catch (e) {
      console.error(e)
      alert("Impossible de lancer la génération. Vérifie les logs.")
      this._setLoading(false)
      this._inFlight = false
    }
  }

  _startPolling() {
    this._stopPolling()
    this._pollTimer = setInterval(() => this._pollOnce(), 1200)
    this._pollOnce()
  }

  _stopPolling() {
    if (this._pollTimer) clearInterval(this._pollTimer)
    this._pollTimer = null
  }

  async _pollOnce() {
    this._pollAttempts += 1

    // garde-fou ~ 60 * 1.2s = 72s
    if (this._pollAttempts > 60) {
      this._stopPolling()
      alert("La génération prend trop de temps. Réessaie ou vérifie les logs.")
      this._setLoading(false)
      this._inFlight = false
      return
    }

    try {
      const resp = await fetch(this.statusUrlValue, {
        method: "GET",
        headers: { "Accept": "application/json" }
      })
      if (!resp.ok) throw new Error(await resp.text())

      const data = await resp.json()

      if (data.status === "done") {
        this._stopPolling()
        this._setStructureValue(data.structure || "")
        this._showSuccess()
        this._setLoading(false)
        this._inFlight = false
        return
      }

      if (data.status === "failed") {
        this._stopPolling()
        console.error(data.error)
        alert("La génération a échoué. Vérifie les logs (détails en console).")
        this._setLoading(false)
        this._inFlight = false
        return
      }

      // running/idle -> on continue
    } catch (e) {
      console.error(e)
      // erreur réseau ponctuelle : on continue à poll
    }
  }

  _setStructureValue(value) {
    const el = this.structureFieldTarget

    if (window.jQuery && window.jQuery(el).data("summernote")) {
      window.jQuery(el).summernote("code", value)
    } else {
      el.value = value
    }

    el.dispatchEvent(new Event("input", { bubbles: true }))
  }

  _setLoading(isLoading) {
    if (isLoading && this.hasSuccessTarget) {
      this.successTarget.classList.add("d-none")
    }

    if (this.hasButtonTarget) {
      this.buttonTarget.disabled = isLoading
    }

    if (this.hasButtonLabelTarget) {
      this.buttonLabelTarget.textContent = isLoading
        ? "Génération en cours…"
        : "Générer le commentaire de structure par IA"
    }

    if (this.hasLoaderTarget) {
      this.loaderTarget.classList.toggle("d-none", !isLoading)
    }
  }

  _showSuccess() {
    if (!this.hasSuccessTarget) return
    const time = new Date().toLocaleTimeString("fr-FR")
    this.successTarget.textContent = ` - Texte généré avec succès (à ${time}) 🚀`
    this.successTarget.classList.remove("d-none")
  }

  _csrfToken() {
    const meta = document.querySelector('meta[name="csrf-token"]')
    return meta ? meta.content : ""
  }
}
